export default {
  mounted() {
      document.documentElement.setAttribute("data-fitter", "true");
        let fadeUpObserve = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add("in-view");
              fadeUpObserve.unobserve(e.target);
            }
          });
        });

        document
          .querySelectorAll(
            ".scroll-fade-up, .scroll-fade-right, .scroll-fade-left"
          )
          .forEach((el) => fadeUpObserve.observe(el));
        console.log(
          document.querySelectorAll(
            ".scroll-fade-up, .scroll-fade-right, .scroll-fade-left"
          )
        );
  },
  destroyed() {
    document.documentElement.removeAttribute("data-fitter");
  },
};
